import { CircleAlert } from "lucide-react";
import styled from "styled-components";

const StyledCircleAlert = styled(CircleAlert)`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  color: var(--alert-danger);
`;

const Wrapper = styled.div`
  width: 100%;
  margin: 20px 0;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border: 1px solid var(--alert-danger);
`;

const Message = styled.p`
  color: var(--alert-danger);
`;

export const ErrorMessage = ({ children }) => {
  if (!children) {
    return null;
  }

  return (
    <Wrapper>
      <StyledCircleAlert size={24} />
      <Message>{children}</Message>
    </Wrapper>
  );
};
